
import { Component, Prop, Vue } from "vue-property-decorator";
import DeletePopover from "@/components/DeletePopover.vue";
import Lender from "@/models/Liink/Lender";
import LoanRule from "@/models/Liink/LoanRule";
import Catalog from "@/models/Liink/Catalog";

@Component({ components: { DeletePopover } })
export default class LoanRuleCard extends Vue {
  @Prop() rules!: Array<LoanRule>;
  @Prop() lenders!: Array<Lender>;
  @Prop() employmentStatusCatalog!: Array<Catalog>;
  @Prop() employmentTimeWorkedCatalog!: Array<Catalog>;

  deleteRule(id: number) {
    this.$emit("delete", id);
  }

  updateRule(rule: LoanRule) {
    this.$emit("update", rule);
  }

  createRule() {
    this.$emit("create");
  }

  lender(id: number) {
    const lender = this.lenders.find(lender => lender.id == id);

    if (!lender) return "-";

    return lender.name;
  }

  employmentStatus(id: number) {
    const employmentStatus = this.employmentStatusCatalog.find(
      employmentStatus => employmentStatus.id == id
    );

    if (!employmentStatus) return "-";

    return employmentStatus.name;
  }

  employmentTimeWorked(id: number) {
    const employmentTimeWorked = this.employmentTimeWorkedCatalog.find(
      employmentTimeWorked => employmentTimeWorked.id == id
    );

    if (!employmentTimeWorked) return "-";

    return employmentTimeWorked.name;
  }
}
